<template>
  <div class="galerija-view">
    <header class="galerija-view__header">
      <div class="galerija-view__header-top">
        <div>
          <h2 class="galerija-view__title">Galerija</h2>
        </div>
        <button type="button" class="galerija-view__btn-create" @click="goToNewAlbum">
          <span class="material-symbols-outlined">add</span>
          Create Album
        </button>
      </div>
    </header>

    <div class="galerija-view__body">
      <div class="galerija-view__card">
        <table class="galerija-view__table">
          <thead>
            <tr>
              <th class="galerija-view__th galerija-view__th--drag" />
              <th class="galerija-view__th">Name</th>
              <th class="galerija-view__th galerija-view__th--actions">Actions</th>
            </tr>
          </thead>
          <tbody class="galerija-view__tbody">
            <tr
              v-for="(album, index) in albums"
              :key="album.id"
              class="galerija-view__row"
              :class="{ 'galerija-view__row--dragging': draggedIndex === index }"
              draggable="true"
              @dragstart="onDragStart($event, index)"
              @dragend="onDragEnd"
              @dragover.prevent="onDragOver($event, index)"
              @drop="onDrop(index)"
            >
              <td class="galerija-view__td galerija-view__td--drag" @click.stop>
                <span class="material-symbols-outlined galerija-view__drag-handle" aria-hidden="true">drag_indicator</span>
              </td>
              <td class="galerija-view__td galerija-view__td--name" @click="goToAlbum(album.id)">
                <span class="galerija-view__folder-name">{{ album.name }}</span>
                <span class="material-symbols-outlined galerija-view__link-icon">arrow_forward</span>
              </td>
              <td class="galerija-view__td galerija-view__td--actions" @click.stop>
                <div class="galerija-view__row-actions">
                  <button
                    type="button"
                    class="galerija-view__action galerija-view__action--danger"
                    title="Delete"
                    @click="deleteFolder(album)"
                  >
                    <span class="material-symbols-outlined">delete</span>
                  </button>
                </div>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters, mapActions } from 'vuex'
import { Message, MessageBox } from 'element-ui'

export default {
  name: 'Galerija',

  components: {},

  data () {
    return {
      draggedIndex: null
    }
  },

  computed: {
    ...mapGetters('galerija', ['albums'])
  },

  mounted () {
    this.load()
  },

  methods: {
    ...mapActions('galerija', ['load', 'deleteAlbum', 'reorderAlbums']),

    goToNewAlbum () {
      this.$router.push({ name: 'GalerijaAlbum', params: { id: 'new' } })
    },

    goToAlbum (id) {
      this.$router.push({ name: 'GalerijaAlbum', params: { id } })
    },

    onDragStart (e, index) {
      this.draggedIndex = index
      e.dataTransfer.effectAllowed = 'move'
      e.dataTransfer.setData('text/plain', String(index))
      e.dataTransfer.setDragImage(e.currentTarget, 0, 0)
    },

    onDragEnd () {
      this.draggedIndex = null
    },

    onDragOver (e, index) {
      if (this.draggedIndex === null) return
      e.dataTransfer.dropEffect = 'move'
    },

    onDrop (dropIndex) {
      if (this.draggedIndex === null || this.draggedIndex === dropIndex) return
      const ids = [...this.albums.map((a) => a.id)]
      const [moved] = ids.splice(this.draggedIndex, 1)
      ids.splice(dropIndex, 0, moved)
      this.reorderAlbums(ids)
      this.draggedIndex = null
    },

    async deleteFolder (album) {
      try {
        await MessageBox.confirm(
          `Delete album "${album.name}"?`,
          'Delete album',
          {
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel',
            type: 'warning'
          }
        )
        await this.deleteAlbum(album.id)
        Message.success('Album deleted.')
      } catch {}
    }
  }
}
</script>

<style lang="scss" scoped>
.galerija-view {
  display: flex;
  flex-direction: column;
  flex: 1;
  min-height: 0;
  font-family: 'Manrope', sans-serif;
}

.galerija-view__header {
  background: rgba(255, 255, 255, 0.7);
  backdrop-filter: blur(24px);
  padding: 2rem 3rem;
  flex-shrink: 0;
  border-bottom: 1px solid #f1f5f9;
}

.galerija-view__header-top {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.galerija-view__title {
  font-size: 2.25rem;
  font-weight: 800;
  letter-spacing: -0.025em;
  color: #0f172a;
  margin: 0;
}

.galerija-view__btn-create {
  display: inline-flex;
  align-items: center;
  gap: 0.5rem;
  padding: 0.75rem 1.5rem;
  background: #1a1a1a;
  color: #fff;
  font-size: 0.875rem;
  font-weight: 600;
  border-radius: 9999px;
  border: none;
  cursor: pointer;
  transition: background 0.15s;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.05);
  .material-symbols-outlined {
    font-size: 0.875rem;
  }
  &:hover {
    background: #334155;
  }
}

.galerija-view__body {
  flex: 1;
  min-height: 0;
  overflow: auto;
  padding: 2rem 3rem;
}

.galerija-view__card {
  background: #fff;
  border-radius: 2rem;
  border: 1px solid #f1f5f9;
  overflow: hidden;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
}

.galerija-view__table {
  width: 100%;
  border-collapse: collapse;
  text-align: left;
}

.galerija-view__th {
  padding: 1.25rem 1.5rem;
  font-size: 11px;
  font-weight: 700;
  text-transform: uppercase;
  letter-spacing: 0.1em;
  color: #94a3b8;
  border-bottom: 1px solid #f1f5f9;
  &.galerija-view__th--drag {
    width: 3rem;
    padding-left: 1.5rem;
  }
  &.galerija-view__th--actions {
    text-align: right;
    width: 8rem;
  }
}

.galerija-view__tbody {
  border-collapse: collapse;
}

.galerija-view__row {
  transition: background 0.15s;
  cursor: grab;
  &:hover {
    background: rgba(248, 250, 252, 0.5);
    .galerija-view__row-actions {
      opacity: 1;
    }
    .galerija-view__link-icon {
      opacity: 1;
    }
  }
  &:active {
    cursor: grabbing;
  }
  &--dragging {
    opacity: 0.5;
    background: #f8fafc;
  }
}

.galerija-view__td {
  padding: 1.5rem 1.5rem;
  border-bottom: 1px solid #f8fafc;
  vertical-align: middle;
  &.galerija-view__td--drag {
    width: 3rem;
    padding-left: 1.5rem;
  }
  &.galerija-view__td--actions {
    text-align: right;
  }
  &--name {
    cursor: pointer;
  }
}

.galerija-view__drag-handle {
  font-size: 1.25rem;
  color: #94a3b8;
  cursor: grab;
  user-select: none;
  &:active {
    cursor: grabbing;
  }
}

.galerija-view__folder-name {
  font-size: 0.9375rem;
  font-weight: 500;
  color: #0f172a;
}

.galerija-view__link-icon {
  font-size: 1rem;
  color: #94a3b8;
  margin-left: 0.5rem;
  opacity: 0;
  transition: opacity 0.15s;
  vertical-align: middle;
}

.galerija-view__row-actions {
  display: inline-flex;
  align-items: center;
  gap: 0.25rem;
  opacity: 0.85;
  transition: opacity 0.15s;
}

.galerija-view__action {
  display: inline-flex;
  padding: 0.5rem;
  color: #64748b;
  border: none;
  background: none;
  border-radius: 0.75rem;
  cursor: pointer;
  transition: all 0.15s;
  .material-symbols-outlined {
    font-size: 1.25rem;
  }
  &:hover {
    background: rgba(226, 232, 240, 0.5);
    color: #0f172a;
  }
  &--danger:hover {
    background: #fef2f2;
    color: #dc2626;
  }
}

</style>
